import { makeStyles } from '@material-ui/core';

export const styles = makeStyles(theme => ({
    contentContainer: {
		maxWidth: '100%',
        padding: 0,
        [theme.breakpoints.down('xs')]: {
            padding: '0 7px',
        },
	},
	headerRow: {
        overflowX: 'hidden',
        '-webkit-overflow-scrolling': 'touch',
        display: 'inline-block',
	},
	row: {
        display: 'grid',
        gridTemplateColumns: 'minmax(280px, 280px)',
        gridAutoFlow: 'column',
        gridAutoColumns: 108,
        '-webkit-overflow-scrolling': 'touch',
        '&::-webkit-scrollbar': {
            display: 'none'
        },
        [theme.breakpoints.down('1280')]: {
            gridAutoColumns: 'calc((100vw - 280px) / 9)',
        },
        [theme.breakpoints.down('1180')]: {
            gridAutoColumns: 'calc((100vw - 280px) / 8)',
        },
        [theme.breakpoints.down('1080')]: {
            gridAutoColumns: 'calc((100vw - 280px) / 7)',
        },
        [theme.breakpoints.down('980')]: {
            gridAutoColumns: 'calc((100vw - 280px) / 6)',
        },
        [theme.breakpoints.down('880')]: {
            gridAutoColumns: 'calc((100vw - 280px) / 5)',
        },
        [theme.breakpoints.down('780')]: {
            gridAutoColumns: 'calc((100vw - 280px) / 4)',
        },
        [theme.breakpoints.down('680')]: {
            gridAutoColumns: 'calc((100vw - 280px) / 3)',
        },
        [theme.breakpoints.down('xs')]: {
            gridTemplateColumns: 'minmax(144px, 144px)',
            gridAutoColumns: 'minmax(94px,1fr)',
        },
        background: 'linear-gradient(90deg, rgba(196, 196, 196, 0.37) 0%, rgba(196, 196, 196, 0) 2.37%)',
	},
	heading: {
        height: '40px',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'sticky',
        top: 0,
        zIndex: 1,
        fontWeight: 400,
        color: '#232326',
        [theme.breakpoints.up('sm')]: {
            alignItems: 'flex-end !important',
            fontSize: 14,
            height: '51px',
        },
        '& img': {
            width: '65px',
            maxHeight: '22px',
            objectFit: 'contain',
            marginBottom: 4,
            [theme.breakpoints.up('sm')]: {
                maxHeight: '22px',
                width: '70px',
            }
        },
        '& a': {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'flex-end',
        },
	},
	table: {
        position: 'relative',
        overscrollBehavior: 'contain',
        fontSize: '12px',
        lineHeight: '150%',
        letterSpacing: '0.3px',
        height: '100%',
        paddingLeft: 0,
        paddingRight: 0,
        '& > div': {
            scrollbarWidth: 'none',
        }
	},
	header: {
        top: 143,
        position: 'sticky',
        zIndex: 5,
        maxHeight: 52,
        backgroundColor: 'white',
        borderBottom: '1px solid #E5E5E5',
        width: '100%',
        [theme.breakpoints.down('xs')]: {
            maxHeight: '43px',
        },
        '& > div': {
            scrollbarWidth: 'none',
        }
	},
	items: {
        overflowY: 'hidden',
        '-webkit-overflow-scrolling': 'touch',
        height: '100%',
        scrollbarWidth: 'none',
	},
	stickyGameDateDiv: {
        position: 'sticky',
        top: 143,
        zIndex: 10,
    },
    gameDateAbsoluteDiv: {
        position: 'absolute',
        left: '0',
        width: '280px',
        [theme.breakpoints.down('xs')]: {
            width: '144px',
            maxHeight: '40px',
        },
	},
	chevronRight: {
        display: 'block',
        position: 'absolute',
        right: -16,
        top: 24,
        width: 16,
        objectFit: 'scale-down',
        "&:hover": {
            backgroundColor: `rgba(0,0,0,0.1)`
        },
        cursor: 'pointer',
        zIndex: 100,
        [theme.breakpoints.down('xs')]: {
            height: 40,
        },
    },
    chevronLeft: {
        display: 'block',
        position: 'absolute',
        left: 263,
        top: 24,
        width: 16,
        objectFit: 'scale-down',
        "&:hover": {
            backgroundColor: `rgba(0,0,0,0.1)`
        },
        cursor: 'pointer',
        zIndex: 100,
        [theme.breakpoints.down('xs')]: {
            height: 40,
            left: 124,
        },
	},
	stickyDiv: {
        position: 'sticky',
        top: 143,
        [theme.breakpoints.down('xs')]: {
            display: 'none',
        },
        zIndex: 11,
	},
	gameDateHeader: {
		zIndex: 100,
		width: '100%',
        position: 'absolute',
		height: 51,
        [theme.breakpoints.down('xs')]: {
            maxHeight: 41,
            background: 'white',
        },
        fontSize: 14,
		fontWeight: 400,
		justifyContent: 'space-between',
        backgroundColor: 'white',
	},
	teamHeader: {
		flex: 1,
		textAlign: 'center',
	},
	openHeader: {
		marginRight: 25,
		[theme.breakpoints.down('xs')]: {
            marginRight: 10,
        },
    },
    pickTitle: {
        fontSize: 18,
        position: 'sticky',
        left: 0,
        padding: '15px 0',
        borderBottom: '1px solid #E5E5E5',
        '&:first-of-type': {
            marginTop: 15,
        }
    },
    shadow: {
        boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.1)',
    },
}));

